import Vue from 'vue';
import Router from 'vue-router';
import store from '@/core/store/index';

const Home = () => import('@/modules/home/Index');
const Login = () => import('@/modules/login/Index');
const DefaultView = () => import('./components/core/DefaultView');
const Events = () => import('@/modules/events/index');
const EventRules = () => import('@/modules/eventRules/index');
const ViewEvent = () => import('@/modules/events/modules/viewEvent/index');
const Chats = () => import('@/modules/chats/Index');
const ChatRules = () => import('@/modules/chats/modules/chatRules/index.vue');
const GeneralChatRules = () => import('@/modules/chats/components/GeneralChatRules.vue');
const Creators = () => import('@/modules/creators/Index');
const Profile = () => import('@/modules/profile/Index');
const Admin = () => import('@/modules/admin/Index');
const Setup = () => import('@/modules/setup/Index.vue');
const StandardPage = () => import('@/modules/standardPage/Index');


const Connect = () => import('@/modules/connect');
const ConnectTelegram = () => import('@/modules/connect/components/ConnectTelegram');

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      component: DefaultView,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home,
        },
        {
          path: '/',
          component: StandardPage,
          meta: {
            requiresAuth: false,
          },
          children: [
            {
              path: '/events',
              name: 'Events',
              component: Events
            },
            {
              path: '/events/rules',
              name: 'EventRules',
              component: EventRules
            },
            {
              path: '/events/:id',
              name: 'ViewEvent',
              component: ViewEvent
            },
            {
              path: '/chats',
              name: 'Chats',
              component: Chats
            },
            {
              path: '/chats/general-rules',
              name: 'GeneralChatRules',
              component: GeneralChatRules
            },
            {
              path: '/chats/rules/:id',
              name: 'ChatRules',
              component: ChatRules
            },
            {
              path: '/creators',
              name: 'Creators',
              component: Creators
            },
          ]
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/admin',
          name: 'Admin',
          component: Admin,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      props: true
    },
    {
      path: '/connect',
      name: 'Connect',
      component: Connect,
      children: [
        {
          path: '/connect/telegram',
          name: "ConnectTelegram",
          component: ConnectTelegram
        }
      ]
    },
    {
      path: '/setup',
      name: 'Setup',
      component: Setup,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*',
      redirect: "/"
    },
  ],
});

async function getUserProfile() {
  return new Promise((resolve) => {
    const { userProfile } = store.state.user;
    if (userProfile !== 'verifying') {
      resolve(userProfile);
    } else {
      const unwatch = store.watch(
        state => state.user.userProfile,
        (value) => {
          if (value !== 'verifying') {
            unwatch();
            resolve(value);
          }
        },
      );
    }
  });
}

async function getUserAuth() {
  return new Promise((resolve) => {
    const { currentUser } = store.state.user;
    if (currentUser !== 'verifying') {
      resolve(currentUser);
    } else {
      const unwatch = store.watch(
        state => state.user.currentUser,
        (value) => {
          if (value !== 'verifying') {
            unwatch();
            resolve(value);
          }
        },
      );
    }
  });
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = await getUserAuth();

  if(currentUser) {
    const userProfile = await getUserProfile();
    if(!userProfile && to.path !== '/setup') {
      next('/setup');
      return;
    }
  }

  if (requiresAuth && !currentUser) {
    next('/login');
  }

  next();
});


export default router
